import colors from 'colors'
import styled from 'styled-components'

const Button = styled.div`
  height: 48px;

  display: flex;
  align-items: center;
  justify-content: center;

  user-select: none;
  cursor: pointer;
  z-index: 1;

  color: white;
  background-color: ${colors.beige};
  box-shadow: 0px 4px 0px 0px ${colors.darkBeige};
  border-radius: 24px;
`

export default Button
